import Competition from './Competition';

export default Competition;
